import { Box, Chip,  } from "@mui/material";
import { FC } from "react";


const Metrics: FC<any> = ({ data }) => {
  
  return (
    <Box sx={{ display: "flex", justifyContent: "start", gap: "0.5rem" }}>
                <Chip
                  label={data?.critical | 0}
                  size="small"
                  sx={{
                    minWidth: "4em",
                    justifyContent: "center",
                    color: "text.primary",
                    borderWidth: 1.5,
                  }}
                  variant={"outlined"}
                  //@ts-ignore
                  color={"critical"}
                />
                <Chip
                  label={data?.high | 0}
                  size="small"
                  sx={{
                    minWidth: "4em",
                    justifyContent: "center",
                    color:  "text.primary" ,
                    borderWidth: 1.5,
                  }}
                  variant={"outlined"}
                  color={"error"}
                />
                <Chip
                  label={data?.medium | 0}
                  size="small"
                  sx={{
                    minWidth: "4em",
                    justifyContent: "center",
                    color: "text.primary",
                    borderWidth: 1.5,
                  }}
                  variant={"outlined"}
                  color={ "warning" }
                />
                <Chip
                  label={data?.low | 0}
                  size="small"
                  sx={{
                    minWidth: "4em",
                    justifyContent: "center",
                    color: "text.primary" ,
                    borderWidth: 1.5,
                  }}
                  variant={"outlined"}
                  color={"info"}
                />
                <Chip
                  label={data?.information | 0}
                  size="small"
                  sx={{
                    minWidth: "4em",
                    justifyContent: "center",
                    color: "text.primary" ,
                    borderWidth: 1.5,
                  }}
                  variant={"outlined"}
                  //@ts-ignore
                  color={"information" }
                />
              </Box>
  );
};

export default Metrics;